var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.805 98.7338S98.7512 151.704 98.6954 151.704l-41.3236-39.435 4.071-27.8499 37.7545 36.1489 34.5197-30.8574c5.896-5.6064 10.018-12.8153 11.857-20.7359 1.839-7.9206 1.314-16.2058-1.51-23.8317-2.823-7.6259-7.823-14.2583-14.379-19.0776-6.557-4.8193-14.383-7.6144-22.513-8.0397H40.2512c-.0898-.0343-.1891-.0343-.2788 0L18 173.983h112.204c6.028.169 12.024-.943 17.59-3.262 5.566-2.318 10.575-5.79 14.698-10.187 4.122-4.396 7.263-9.616 9.215-15.315s2.67-11.747 2.107-17.744c-.657-5.691-2.481-11.186-5.36-16.14-2.879-4.955-6.749-9.264-11.37-12.6569 0 0-.223-.0557-.279.0557Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 115.135,
    y1: 198.802,
    x2: 202.154,
    y2: 78.1346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1B9AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C3DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "21d52a472a22036407cbb00a98e214b2.svg";
export { ForwardRef as ReactComponent };